import {Fragment, h} from 'preact';
import { formatPriceWithSymbol } from  '../../tools';

export default function BlockItem({item}){
    return (
        <div data-id={item.method} className="block-item account-details__block">
            <div className="row">
                <div className={'col col-12 col-lg-6 account-details__legend-item account-details__legend-item_' + item.method}>
                    {item.title}
                </div>
                <div className="col col-12 col-lg-6">
                    {formatPriceWithSymbol(item.amount)}
                </div>
            </div>
        </div>
    )
}
